import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import Lottie from "lottie-react";
import loaderAnimation from "./loader.json"; // Importing your JSON file
import "./loader.css";

export default function Loader(props) {
  const lottieRef = useRef();

  const lottieStyle = {
    height: 140,
    width: 140,
    margin: "0 auto",
  };

  useEffect(() => {
    if (lottieRef.current) {
      lottieRef.current.setSpeed(1.5);
    }
  }, [props.visible]);

  return props.visible
    ? ReactDOM.createPortal(
        <div className="loader-main">
          <Lottie
            lottieRef={lottieRef}
            animationData={loaderAnimation}
            loop={true}
            style={lottieStyle}
            speed={2}
          />

          <div className="loader-text" id="loader-parent-text">
            Hang tight — something amazing is loading...
          </div>
        </div>,
        document.getElementById("portal-loader")
      )
    : null;
}
